import React, { useMemo } from "react";
import { ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import { useStyles } from "./FiltersButton.styles";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { IFiltersButtonProps } from "./FiltersButtonInterfaces";
import { useTranslation } from "react-i18next";

export const FiltersButton = ({ showFilters, handleShowFiltersChange, isFilterApplied }: IFiltersButtonProps) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const { buttonClassName, indicateFiltersApplied } = useMemo(
        () => ({
            buttonClassName: `${classes.headerFilterButton} ${
                isFilterApplied && !showFilters ? classes.filtersAppliedHidden : ""
            }`,
            indicateFiltersApplied: isFilterApplied && !showFilters,
        }),
        [classes, isFilterApplied, showFilters],
    );

    const buttonGroup = useMemo(
        () => (
            <ToggleButtonGroup
                color="info"
                className={buttonClassName}
                value={showFilters && "filter"}
                exclusive
                onChange={() => handleShowFiltersChange(!showFilters)}
            >
                <ToggleButton value="filter">
                    <FilterAltOutlinedIcon />
                </ToggleButton>
            </ToggleButtonGroup>
        ),
        [buttonClassName, showFilters, handleShowFiltersChange],
    );

    return (
        <div className={classes.headerActionWrapper}>
            {indicateFiltersApplied ? (
                <Tooltip
                    placement="top"
                    PopperProps={{
                        className: classes.tooltip,
                    }}
                    title={
                        <Typography className={classes.tooltipTexts}>
                            {t("locations.mill_dashboards.filters_applied")}
                        </Typography>
                    }
                >
                    {buttonGroup}
                </Tooltip>
            ) : (
                buttonGroup
            )}
        </div>
    );
};
